import { render } from "./EventRegister.vue?vue&type=template&id=29e882a6"
import script from "./EventRegister.vue?vue&type=script&lang=js"
export * from "./EventRegister.vue?vue&type=script&lang=js"
script.render = render

export default script